import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "rule-binder";

export const store = configureStore({
    reducer,
});
